import { getMonetateExperience } from './getMonetateExperience';

export const getMonetateParams = (
  features?: Features,
  partialExperienceName?: string
): Record<string, string> =>
  getMonetateExperience(features, partialExperienceName)?.parameters || {};

export const getMonetateParamsValue = (
  features?: Features,
  partialExperienceName?: string,
  paramName = ''
): string => {
  const parameters =
    getMonetateExperience(features, partialExperienceName)?.parameters || {};

  return parameters?.[paramName] ?? '';
};

export const getExperiencesWithMatchingParamValues = (
  features?: Partial<Features>,
  paramName = '',
  paramValue = ''
): MonetateExperience[] => {
  return (
    features?.monetateExperiences?.filter(({ parameters }) =>
      parameters?.[paramName]
        ?.split('|')
        .some(value => value.toLowerCase() === paramValue.toLowerCase())
    ) || []
  );
};
